<style>
#scadaSettingsModal .v--modal-box.v--modal {
  min-width: 380px !important;
  min-height: 400px !important;
}
#scadaSettingsModal .modal__content {
  overflow-y: hidden !important;
}
#scadaSettingsModal .v-input__slot,
#scadaSettingsModal label {
  font-size: 12px;
}
#scadaSettingsModal .menuable__content__active {
  max-height: 200px;
}
</style>

<template>
  <Modal
    modalName="scadaSettingsModal"
    title="Konfiguracja modułu SCADA"
    :buttons="['save']"
    @saved="saveInterval"
    @opened="loadInterval"
  >
    <v-layout row wrap>
      <v-flex xs12 id="modalSelect__scadaSettings">
        <v-select
          :items="intervalValues"
          v-model="scadaInterval"
          :value="scadaInterval"
          label="Ustawienie interwału pobierania danych SCADA (w minutach)"
          attach="#modalSelect__scadaSettings .v-input__slot"
        ></v-select>
      </v-flex>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    intervalValues: ["0.5", "1", "5", "10", "15", "30", "60"],
    scadaInterval: 0
  }),
  computed: {
    getInterval() {
      return this.$store.getters.getScadaInterval;
    }
  },
  methods: {
    saveInterval() {
      const self = this;
      this.$store.commit("setScadaInterval", +self.scadaInterval);
      this.$modal.hide("scadaSettingsModal");
    },
    loadInterval() {
      this.scadaInterval = this.getInterval;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/modals/ScadaSettings.vue